<template>
  <div>
    <v-list dense shaped color="transparent">
      <v-list-item-group color="primary">
        <v-list-item
          v-for="(key, index) in optionKeys"
          :key="index"
          :to="'/cls/' + key.toLowerCase()"
        >
          <v-list-item-icon>
            <img :src="imageUrl(key)" height="20" width="20" class="mr-2" />
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title
              ><span v-text="labelText(index)"></span
            ></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
// * note : this holds an object that contains all the labels and images used above
import FilterDictionary from "@/assets/js/cls/FilterDictionary";
import HardLinksMixin from "@/assets/js/HardLinksMixin";

export default {
  name: "SelectSoftType",
  mixins: [HardLinksMixin],
  props: {
    // noAnyBifOrCosmetic: {
    //   // wtf is this?
    //   type: Boolean,
    //   default: false,
    // },
    external: {
      type: String,
      default: "ANY",
    },
  },
  data: function () {
    return {
      //imagePath: "/images/icons/lensTypes/",
      // selectedItem: 0, // an index from the options array
    };
  },
  computed: {
    optionKeys: function () {
      let keys = Object.keys(FilterDictionary.filterOptions.type);
      keys.shift(); // remove the first item ("ANY") - we don't want this for the menu
      return keys;
    },
  },
  methods: {
    // convenience function - takes an index from the optionKeys array and finds the key
    typeObjForIndex(index) {
      let key = this.optionKeys[index];
      return this.typeObjForKey(key);
    },
    // uses a key and gets a lens type object from FilterDictionary.lensTypeOptions object
    typeObjForKey(key) {
      return FilterDictionary.filterOptions.type[key];
    },
    labelText(index) {
      return this.typeObjForIndex(index).label;
    },
    imageUrl(index) {
      let img = FilterDictionary.imageForType(index);
      if (!img) return null;
      return `${this.CL_TYPE_DIR}/${img}`;
      // let itemForIndex = this.typeObjForIndex(index);
      // let file = itemForIndex.image;
      // let url = this.imagePath + file + "_icon";
      // url += "_active.svg";
      // return url;
    },
    // setSelectedItemForKey(key) {
    //   if (!key) return;
    //   let index = this.optionKeys.indexOf(key.toUpperCase());
    //   if (index != this.selectedItem) this.selectedItem = index;
    // },
  },
  // created: function() {
  //   if (this.noAnyBifOrCosmetic == true) {
  //     this.typeData.bifocal.value = this.typeData.cosmetic.value = "0";
  //   }
  // },
  watch: {
    /*
    selectedItem(index) {
      let val = this.optionKeys[index];
      this.$store.dispatch("setFilterValue", { key: "type", value: val });
      if (this.external != val) this.$emit("type", val);
    },
    external(val) {
      // for when the external val is set externally by the prop
      this.setSelectedItemForKey(val);
    },
    */
  },
  mounted: function () {
    // console.log("mounting typeSelector: " + this.external);
    // this.setSelectedItemForKey(this.external);
  },
};
</script>

<style scoped>
/* .selectedClass {
  border: 1px solid rgb(164, 112, 0) !important;
  background-color: #fff9f3 !important;
  color: rgb(164, 112, 0) !important;
} */
/* .iconClass {
  border-color: transparent;
  padding: 1px;
} */
/* 
.buttonCell {
  display: table-cell;
}

.buttonCell div {
  border: 1px solid rgb(176, 176, 176);
  background-color: white;
  margin: 0 2px;
  cursor: pointer;
  width: 32px;
  border-radius: 2px;
  text-align: center;
  color: rgb(176, 176, 176);
} */
.grayText {
  color: #636363;
}
.v-list-item--dense .v-list-item__icon,
.v-list--dense .v-list-item .v-list-item__icon,
.v-list-item__content {
  padding: 3px 0 !important;
  margin: 0 !important;
}
.v-list-item--dense,
.v-list--dense .v-list-item {
  min-height: 30px;
}
</style>
